export function formatWithThousandsSeparators(value) {
  const [integerPart, decimalPart] = String(value).split(".");
  const formattedIntegerPart = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  );
  return decimalPart
    ? `${formattedIntegerPart}.${decimalPart}`
    : formattedIntegerPart;
}

export function formatDateStringWithoutTime(dateString) {
  const options = { month: "short", day: "numeric", year: "numeric" };
  return new Date(dateString).toLocaleDateString(undefined, options);
}

export const formatDateTime = (dateString) => {
  const options = {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true, // ensures am/pm is included
  };
  return new Date(dateString).toLocaleString(undefined, options);
};
